// extracted by mini-css-extract-plugin
module.exports = {"pageLayout":"page-layout-module--page-layout--1rKF2","footer":"page-layout-module--footer--3Pb6K"};